import { render, staticRenderFns } from "./learningCenterNewsTab.vue?vue&type=template&id=1316f28e&"
import script from "./learningCenterNewsTab.vue?vue&type=script&lang=js&"
export * from "./learningCenterNewsTab.vue?vue&type=script&lang=js&"
import style0 from "../less/learningCenterNewsTab.less?vue&type=style&index=0&module=true&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["../less/learningCenterNewsTab.less?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("../less/learningCenterNewsTab.less?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("1316f28e")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1316f28e')) {
      api.createRecord('1316f28e', component.options)
    } else {
      api.reload('1316f28e', component.options)
    }
    module.hot.accept("./learningCenterNewsTab.vue?vue&type=template&id=1316f28e&", function () {
      api.rerender('1316f28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/learningCenter/components/learningCenterNewsTab.vue"
export default component.exports